import { Page } from "@/models";
import { Romaneio, RomaneioForm } from "@/models/Romaneio";
import { Inject } from "inversify-props";
import { EstoqueServiceAdapter } from "../deposito/adapter";

export class RomaneioEstoqueUseCase {

	@Inject('EstoqueServiceAdapter')
	private estoqueService!: EstoqueServiceAdapter

	async salvarRomaneio(romaneioForm: RomaneioForm): Promise<any> {
		this.estoqueService.salvarRomaneio(romaneioForm)
	}

	async findRomaneioPendente(depositoId: string): Promise<Page<Romaneio>> {
		return this.estoqueService.findRomaneio(depositoId)
	} 

	async update(romaneio: RomaneioForm): Promise<void> {
		return this.estoqueService.update(romaneio)
	}
}
